import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import cx from 'classnames';
import GstTableHeaderDisclaimer from '../../GstTableHeaderDisclaimer';
import ProductUnitPrice from '../ProductUnitPrice';
import { priceDisplayFormat } from '@app/utils/paymentUtils';
import { PCC_PDP_LUCID_TAX_DISCLAIMER } from '@app/constants/featureFlags';
import Conditional from '@app/components/common/Conditional';

const ProductOverviewPriceDetails = ({
  className,
  currency,
  price,
  unitPrice,
  taxDisclaimerMessage
}) => {
  const taxMessageGSTByXOrder = useSelector(
    s => s.orders?.taxDisclaimerMessage
  );
  const taxDisclaimerFeatureFlag = useSelector(
    s => s.featureFlag?.[PCC_PDP_LUCID_TAX_DISCLAIMER]
  );

  return (
    <>
      <p
        className={cx(
          'text-xl text-univers u-color--ExtraDarkGray mb-0',
          className
        )}
        data-price
      >
        {priceDisplayFormat({
          price,
          currency,
          priceWrapperClasses:
            'text-xl text-univers--bold u-color--ExtraDarkGray'
        })}
      </p>
      <ProductUnitPrice
        currency={currency}
        price={price}
        unitPrice={unitPrice}
      />
      <Conditional
        test={
          (taxDisclaimerFeatureFlag &&
            (taxDisclaimerMessage || taxMessageGSTByXOrder)) ||
          !taxDisclaimerFeatureFlag
        }
      >
        <p className="mb-0">
          <GstTableHeaderDisclaimer
            className="fw-normal"
            taxDisclaimerMessage={taxDisclaimerMessage || taxMessageGSTByXOrder}
          />
        </p>
      </Conditional>
    </>
  );
};

ProductOverviewPriceDetails.propTypes = {
  className: PropTypes.string,
  currency: PropTypes.string,
  price: PropTypes.string,
  taxDisclaimerMessage: PropTypes.string,
  unitPrice: PropTypes.string
};

export default ProductOverviewPriceDetails;
